// extracted by mini-css-extract-plugin
module.exports = {"container":"PostType_container__2F8vk","checkmark":"PostType_checkmark__MOlxO"};